import { createFileRoute, redirect } from "@tanstack/react-router";
import { OnboardingPage } from "@/features/onboarding/pages/onboarding-page";
import { storesQueryOptions } from "@/hooks/use-stores";
import { isAuthenticated } from "@/lib/auth-utils";

export const Route = createFileRoute("/onboarding")({
	beforeLoad: async ({ context }) => {
		if (!(await isAuthenticated())) {
			throw redirect({ to: "/signin" });
		}

		const stores = await context.queryClient.fetchQuery({
			...storesQueryOptions,
			staleTime: 0,
		});
		if (stores.length > 0) {
			throw redirect({ to: "/$store", params: { store: stores[0].slug } });
		}
	},
	component: OnboardingPage,
});
